(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-entry-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-lazy-video')) {
    class PbLazyVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!('IntersectionObserver' in window)) return this.load();
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.load();
                if (!this.reduced) this.video.play().catch(() => {});
              } else if (this.loaded) {
                this.video.pause();
              }
            });
          },
          { rootMargin: '200px 0px' }
        );
        this.observer.observe(this);
      }

      load() {
        if (this.loaded) return;
        this.loaded = true;
        const source = this.video.querySelector('source[data-src]');
        if (source) {
          const { src, srcHd, srcHls } = source.dataset;
          const desktop = window.matchMedia('(min-width: 990px)').matches;
          if (srcHls && this.video.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari/iOS: HLS adaptativo según la conexión.
            source.type = 'application/x-mpegURL';
            source.src = srcHls;
          } else {
            source.src = desktop || !src ? srcHd : src;
            source.addEventListener(
              'error',
              () => {
                if (srcHd && source.src !== srcHd) {
                  source.src = srcHd;
                  this.video.load();
                  if (!this.reduced) this.video.play().catch(() => {});
                }
              },
              { once: true }
            );
          }
          source.removeAttribute('data-src');
        }
        if (this.reduced) this.video.controls = true;
        this.video.load();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
    customElements.define('pb-lazy-video', PbLazyVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-pdp-demo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-lazy-video')) {
    class PbLazyVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!('IntersectionObserver' in window)) return this.load();
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.load();
                if (!this.reduced) this.video.play().catch(() => {});
              } else if (this.loaded) {
                this.video.pause();
              }
            });
          },
          { rootMargin: '200px 0px' }
        );
        this.observer.observe(this);
      }

      load() {
        if (this.loaded) return;
        this.loaded = true;
        const source = this.video.querySelector('source[data-src]');
        if (source) {
          const { src, srcHd, srcHls } = source.dataset;
          const desktop = window.matchMedia('(min-width: 990px)').matches;
          if (srcHls && this.video.canPlayType('application/vnd.apple.mpegurl')) {
            source.type = 'application/x-mpegURL';
            source.src = srcHls;
          } else {
            source.src = desktop || !src ? srcHd : src;
            source.addEventListener(
              'error',
              () => {
                if (srcHd && source.src !== srcHd) {
                  source.src = srcHd;
                  this.video.load();
                  if (!this.reduced) this.video.play().catch(() => {});
                }
              },
              { once: true }
            );
          }
          source.removeAttribute('data-src');
        }
        if (this.reduced) this.video.controls = true;
        this.video.load();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
    customElements.define('pb-lazy-video', PbLazyVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__pbPdpInit) return;
    window.__pbPdpInit = true;

    const initGallery = (root) => {
      const track = root.querySelector('[data-pb-gal-track]');
      if (!track) return null;
      const slides = [...track.querySelectorAll('[data-pb-slide]')];
      const thumbs = [...root.querySelectorAll('[data-pb-thumb]')];
      const current = root.querySelector('[data-pb-gal-current]');

      const goTo = (index, smooth = true) => {
        const slide = slides[index];
        if (!slide) return;
        const animate = smooth && document.visibilityState === 'visible';
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: animate ? 'smooth' : 'auto' });
      };

      const setActive = (index) => {
        if (current) current.textContent = String(index + 1);
        thumbs.forEach((t, i) => (i === index ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
      };

      if ('IntersectionObserver' in window && slides.length > 1) {
        const io = new IntersectionObserver(
          (entries) => entries.forEach((e) => e.isIntersecting && setActive(Number(e.target.dataset.pbSlide))),
          { root: track, threshold: 0.6 }
        );
        slides.forEach((s) => io.observe(s));
      }
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.pbThumb))));

      // Video principal: se descarga después del evento load (no compite con la carga inicial),
      // en silencio y en bucle; solo se reproduce mientras está a la vista. Con ahorro de datos o
      // conexión lenta se queda la foto fija.
      const videos = [...track.querySelectorAll('video[data-pb-autoplay]')];
      if (videos.length) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const conn = navigator.connection || {};
        const slow = conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
        if (!reduce && !slow) {
          const start = () => {
            videos.forEach((v) => {
              v.muted = true;
              v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
              v.addEventListener(
                'error',
                () => {
                  if (v.dataset.fallback && v.src !== v.dataset.fallback) {
                    v.src = v.dataset.fallback;
                    v.play?.().catch(() => {});
                  }
                },
                { once: true }
              );
              v.src = v.dataset.src;
              if ('IntersectionObserver' in window) {
                new IntersectionObserver(
                  (entries) =>
                    entries.forEach((e) => {
                      if (e.isIntersecting) e.target.play?.().catch(() => {});
                      else e.target.pause?.();
                    }),
                  { threshold: 0.4 }
                ).observe(v);
              } else {
                v.play?.().catch(() => {});
              }
            });
          };
          // Si el cliente cambia de app y regresa, el navegador pausa el video: se reanuda si está a la vista.
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState !== 'visible') return;
            videos.forEach((v) => {
              const r = v.getBoundingClientRect();
              if (v.src && r.bottom > 0 && r.top < window.innerHeight) v.play?.().catch(() => {});
            });
          });
          const later = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 1500 }) : setTimeout(start, 300));
          if (document.readyState === 'complete') later();
          else window.addEventListener('load', later, { once: true });
        }
      }

      return {
        showMedia(mediaId) {
          const index = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
          if (index > -1) goTo(index);
        },
      };
    };

    // Traduce en pantalla los nombres de opciones y valores de variante (sin tocar el producto).
    const initOptionLabels = (section) => {
      let labels = null;
      try {
        labels = JSON.parse(section.querySelector('[data-pb-option-labels]')?.textContent || 'null');
      } catch (e) {}
      if (!labels) return;
      const scope = () => section.querySelectorAll('#pb-buy variant-picker, [data-pb-offer-pick]');
      const relabel = () => {
        scope().forEach((root) => {
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const raw = node.nodeValue;
            const key = raw.trim();
            if (key && Object.prototype.hasOwnProperty.call(labels, key) && labels[key] !== key) {
              node.nodeValue = raw.replace(key, labels[key]);
            }
          }
          root.querySelectorAll('option').forEach((o) => {
            const key = o.textContent.trim();
            if (labels[key] && labels[key] !== key) o.textContent = labels[key];
          });
        });
      };
      relabel();
      const buy = section.querySelector('#pb-buy');
      if (buy && 'MutationObserver' in window) {
        let queued = false;
        new MutationObserver(() => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            relabel();
          });
        }).observe(buy, { childList: true, subtree: true });
      }
    };

    const init = (section) => {
      initOptionLabels(section);
      const gallery = initGallery(section);
      const buy = section.querySelector('#pb-buy');

      // Sincroniza la galería con la variante elegida: lee las opciones marcadas en el selector
      // (la URL no siempre cambia) y salta a la imagen asignada a esa variante.
      let variantMedia = {};
      try {
        variantMedia = JSON.parse(section.querySelector('[data-pb-variant-media]')?.textContent || '{}');
      } catch (e) {}
      // Horizon vuelve a pintar el bloque de compra al cambiar de variante: se consulta cada vez.
      const selectedOptions = () => {
        const box = section.querySelector('#pb-buy');
        return [...(box?.querySelectorAll('variant-picker fieldset') || [])]
          .map((fs) => fs.querySelector('input:checked')?.value)
          .concat([...(box?.querySelectorAll('variant-picker select') || [])].map((s) => s.value))
          .filter(Boolean);
      };
      const syncGallery = () => {
        if (!gallery) return;
        const picked = selectedOptions();
        const match = Object.values(variantMedia).find(
          (v) => v.media && picked.length && picked.every((val) => v.options.includes(val))
        );
        if (match) gallery.showMedia(match.media);
      };
      document.addEventListener('change', (event) => {
        if (!section.contains(event.target)) return;
        // Oferta 2 tapetes: cada menú de diseño trae la imagen de su variante.
        const offerSelect = event.target.closest('[data-pb-offer-design]');
        if (offerSelect) {
          const media = offerSelect.selectedOptions[0]?.dataset.media;
          if (media && gallery) gallery.showMedia(media);
          return;
        }
        if (!event.target.closest('#pb-buy variant-picker')) return;
        syncGallery();
        setTimeout(syncGallery, 600);
      }, true); // captura: el variant-picker de Horizon detiene la propagación del change

      // Talla por defecto (metafield petbeat.default_size): al abrir sin ?variant marca esa talla.
      let defaultSize = null;
      try {
        defaultSize = JSON.parse(section.querySelector('[data-pb-default-size]')?.textContent || 'null');
      } catch (e) {}
      if (defaultSize && !new URLSearchParams(location.search).has('variant')) {
        const want = String(defaultSize).trim().toLowerCase();
        const pickDefault = () => {
          const input = [...(buy?.querySelectorAll('variant-picker input[type="radio"]') || [])].find(
            (i) => i.value.trim().toLowerCase() === want
          );
          if (!input) return false;
          if (!input.checked) input.click();
          return true;
        };
        if (!pickDefault()) setTimeout(pickDefault, 300);
      }

      // CTA secundarios (sticky, final): usan el formulario nativo de Horizon.
      const addButton = () => buy?.querySelector('button[name="add"]');
      const scrollToBuy = () => buy?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-pb-add], [data-pb-choose]');
        if (!trigger) return;
        const btn = addButton();
        const hasChoices = buy?.querySelector('variant-picker fieldset, variant-picker select');
        if (trigger.hasAttribute('data-pb-choose') || (hasChoices && trigger.closest('[data-pb-sticky]')) || !btn || btn.disabled) {
          scrollToBuy();
          return;
        }
        btn.click();
      });

      // Sticky CTA móvil: aparece cuando el botón principal sale de pantalla.
      const sticky = section.querySelector('[data-pb-sticky]');
      const target = addButton();
      const offerAdd = buy?.querySelector('[data-pb-offer-add]');
      if (sticky && target && 'IntersectionObserver' in window) {
        const price = sticky.querySelector('[data-pb-sticky-price]');
        const syncPrice = () => {
          // Con la oferta 1/2, el bloque de oferta escribe el precio de la barra.
          if (offerAdd) return;
          const live = buy.querySelector('product-price [ref="priceContainer"] .price, product-price .price');
          if (live && price) price.textContent = live.textContent.trim();
        };
        // Visible siempre que ningún botón principal (nativo u oferta) esté en pantalla.
        const visible = new Set();
        new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
            sticky.hidden = visible.size > 0;
            if (!sticky.hidden) syncPrice();
          },
          { threshold: 0 }
        ).observe(target);
        if (offerAdd) {
          // Reutiliza el mismo criterio para el botón de la oferta.
          new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
              sticky.hidden = visible.size > 0;
            },
            { threshold: 0 }
          ).observe(offerAdd);
        }
      }
    };

    const run = () => document.querySelectorAll('[data-pb-pdp]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();

  } catch(e) { console.error(e); }
})();
})();
